import React, { Component } from 'react';
import type { ReactNode } from 'react';
import TableWrapper from '../TableWrapper';
import EmailSubscriptionsTableContent from './table/EmailSubscriptionsTableContent';
import EmailSubscriptionsTableHeader from './table/EmailSubscriptionsTableHeader';
import type { Subscription } from '../../../types';

type Props = {
  subscriptions?: Array<Subscription>;
  onUpdateEmailSubscriptions: (payload: any) => void;
};

class EmailSubscriptionsContent extends Component<Props> {
  render(): ReactNode {
    const { subscriptions, onUpdateEmailSubscriptions } = this.props;

    return (
      <TableWrapper
        className="small-device-project has-custom-table"
      >
        <EmailSubscriptionsTableHeader />
        <EmailSubscriptionsTableContent
          subscriptions={subscriptions}
          onUpdateEmailSubscriptions={onUpdateEmailSubscriptions}
        />
      </TableWrapper>
    );
  }
}

export default EmailSubscriptionsContent;
